import { render, staticRenderFns } from "./tableTextarea.vue?vue&type=template&id=f4afa1a4&scoped=true&"
import script from "./tableTextarea.vue?vue&type=script&lang=js&"
export * from "./tableTextarea.vue?vue&type=script&lang=js&"
import style0 from "./tableTextarea.vue?vue&type=style&index=0&id=f4afa1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4afa1a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdGG/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4afa1a4')) {
      api.createRecord('f4afa1a4', component.options)
    } else {
      api.reload('f4afa1a4', component.options)
    }
    module.hot.accept("./tableTextarea.vue?vue&type=template&id=f4afa1a4&scoped=true&", function () {
      api.rerender('f4afa1a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rw/tempTable/components/tableTextarea.vue"
export default component.exports